import Component from '../Component';

export default class GateComponent extends Component {
    public open: boolean = undefined;
}
